import { render, staticRenderFns } from "./ConductWidgetSettings.vue?vue&type=template&id=5181283b&scoped=true"
import script from "./ConductWidgetSettings.vue?vue&type=script&lang=js"
export * from "./ConductWidgetSettings.vue?vue&type=script&lang=js"
import style0 from "./ConductWidgetSettings.vue?vue&type=style&index=0&id=5181283b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181283b",
  null
  
)

export default component.exports